import { PRICE_HISTORY_SET_MODAL_OPEN } from '../constants';

const DEFAULT_STATE = {
  id: '',
  previouslyLowestPrice: '0',
  numberOfDays: 30,
  description: '',
  title: '',
};

export const priceHistory = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case PRICE_HISTORY_SET_MODAL_OPEN:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
